type ApiErrorResponse = {
  detail_error?: string | string[] | null
  message?: string | null
}

/**
 * Mensagem para mostrar ao usuário quando uma requisição do `DataService`
 * falha. A API costuma mandar um `message` genérico ("Houve um erro ao…") e o
 * motivo real em `detail_error` (ex.: `errors.full_messages`), então o detalhe
 * vem primeiro.
 *
 * Em erro, o `DataService` põe `message`/`detail_error` no topo da resposta e
 * um placeholder em `data` — ler `response.data.message` ali dá `undefined`.
 */
export const apiErrorMessage = (
  response: ApiErrorResponse | null | undefined,
  fallback: string
): string => {
  const detail = Array.isArray(response?.detail_error)
    ? response?.detail_error[0]
    : response?.detail_error

  return detail || response?.message || fallback
}
